import { EMERGENCY_CONTACT_OPTIONS } from "./emergency-contact.utils";
import { EMPLOYMENT_OPTIONS } from "./employment.utils";
import { PATIENT_MISCELLANEOUS_OPTIONS } from "./patient-miscellaneous.utils";
import { PATIENT_NAME_OPTIONS } from "./patient-name.utils";
import { PERSONAL_DETAILS_OPTIONS } from "./personal-details.utils";
import { PRIMARY_CARE_PHYSICIAN_OPTIONS } from "./primary-care-physician.utils";
import { PRIMARY_CONTACT_OPTIONS } from "./primary-contact.utils";
import { REFERRING_PHYSICIAN_OPTIONS } from "./referring-physician.utils";
import { SECONDARY_CONTACT_OPTIONS } from "./secondary-contact.utils";

const PERSONAL_DETAILS_MENU = [
  {
    title: "Patient - Years Old",
    value: PERSONAL_DETAILS_OPTIONS.YEARS_OLD
  },
  {
    title: "Patient - Date of Birth",
    value: PERSONAL_DETAILS_OPTIONS.DATE_OF_BIRTH
  },
  {
    title: "Patient - Sex",
    value: PERSONAL_DETAILS_OPTIONS.SEX
  },
  {
    title: "Patient - Marital Status",
    value: PERSONAL_DETAILS_OPTIONS.MARITAL_STATUS
  },
  {
    title: "Patient - SSN Number",
    value: PERSONAL_DETAILS_OPTIONS.SSN_NUMBER
  }
];

const PERSONAL_DETAILS_PRONOUNS_ITEM = {
  title: "Patient - Pronouns",
  value: PERSONAL_DETAILS_OPTIONS.PRONOUNS
};

const buildPatientInfoMenuOptions = (includePronouns: boolean) => ({
  title: "Patient - Info",
  menu: [
    {
      title: "Name",
      menu: [
        {
          title: "Patient - Full Name",
          value: PATIENT_NAME_OPTIONS.FullName
        },
        {
          title: "Patient - First Name",
          value: PATIENT_NAME_OPTIONS.FirstName
        },
        {
          title: "Patient - Last Name",
          value: PATIENT_NAME_OPTIONS.LastName
        },
        {
          title: "Patient - Middle Initial",
          value: PATIENT_NAME_OPTIONS.MiddleInitial
        },
        {
          title: "Patient - Preferred Name",
          value: PATIENT_NAME_OPTIONS.PreferredName
        },
        {
          title: "Patient - Title",
          value: PATIENT_NAME_OPTIONS.Title
        },
        {
          title: "Patient - Suffix",
          value: PATIENT_NAME_OPTIONS.Suffix
        },
        {
          title: "Patient - Suno ID",
          value: PATIENT_NAME_OPTIONS.SunoId
        }
      ]
    },
    {
      title: "Personal Details",
      menu: includePronouns
        ? [
            PERSONAL_DETAILS_MENU[0],
            PERSONAL_DETAILS_MENU[1],
            PERSONAL_DETAILS_MENU[2],
            PERSONAL_DETAILS_PRONOUNS_ITEM,
            ...PERSONAL_DETAILS_MENU.slice(3)
          ]
        : PERSONAL_DETAILS_MENU
    },
    {
      title: "Primary Contact",
      menu: [
        {
          title: "Patient - Primary Contact - Notes",
          value: PRIMARY_CONTACT_OPTIONS.NOTES
        },
        {
          title: "Patient - Primary Contact - Email Address",
          value: PRIMARY_CONTACT_OPTIONS.EMAIL_ADDRESS
        },
        {
          title: "Patient - Primary Contact - Preferred Communication method",
          value: PRIMARY_CONTACT_OPTIONS.PREFERRED_COMMUNICATION_METHOD
        },
        {
          title: "Patient - Primary Contact - Phone number",
          value: PRIMARY_CONTACT_OPTIONS.PHONE
        },
        {
          title: "Patient - Primary Contact - Type of Phone number",
          value: PRIMARY_CONTACT_OPTIONS.TYPE_OF_PHONE_NUMBER
        },
        {
          title: "Patient - Primary Contact - Full Address",
          value: PRIMARY_CONTACT_OPTIONS.FULL_ADDRESS
        },
        {
          title: "Patient - Primary Contact - Street Address Line 1",
          value: PRIMARY_CONTACT_OPTIONS.STREET_ADDRESS_LINE1
        },
        {
          title: "Patient - Primary Contact - Street Address Line 2",
          value: PRIMARY_CONTACT_OPTIONS.STREET_ADDRESS_LINE2
        },
        {
          title: "Patient - Primary Contact - City",
          value: PRIMARY_CONTACT_OPTIONS.CITY
        },
        {
          title: "Patient - Primary Contact - State",
          value: PRIMARY_CONTACT_OPTIONS.STATE
        },
        {
          title: "Patient - Primary Contact - ZIP Code",
          value: PRIMARY_CONTACT_OPTIONS.ZIP_CODE
        }
      ]
    },
    {
      title: "Secondary Contact",
      menu: [
        {
          title: "Patient - Secondary Contact - Notes",
          value: SECONDARY_CONTACT_OPTIONS.NOTES
        },
        {
          title: "Patient - Secondary Contact - Email Address",
          value: SECONDARY_CONTACT_OPTIONS.EMAIL_ADDRESS
        },
        {
          title: "Patient - Secondary Contact - Phone number",
          value: SECONDARY_CONTACT_OPTIONS.PHONE
        },
        {
          title: "Patient - Secondary Contact - Type of Phone number",
          value: SECONDARY_CONTACT_OPTIONS.TYPE_OF_PHONE_NUMBER
        },
        {
          title: "Patient - Secondary Contact - Full Address",
          value: SECONDARY_CONTACT_OPTIONS.FULL_ADDRESS
        },
        {
          title: "Patient - Secondary Contact - Street Address Line 1",
          value: SECONDARY_CONTACT_OPTIONS.STREET_ADDRESS_LINE1
        },
        {
          title: "Patient - Secondary Contact - Street Address Line 2",
          value: SECONDARY_CONTACT_OPTIONS.STREET_ADDRESS_LINE2
        },
        {
          title: "Patient - Secondary Contact - City",
          value: SECONDARY_CONTACT_OPTIONS.CITY
        },
        {
          title: "Patient - Secondary Contact - State",
          value: SECONDARY_CONTACT_OPTIONS.STATE
        },
        {
          title: "Patient - Secondary Contact - ZIP Code",
          value: SECONDARY_CONTACT_OPTIONS.ZIP_CODE
        }
      ]
    },
    {
      title: "Emergency Contact",
      menu: [
        {
          title: "Patient - Emergency Contact - Relationship to Patient",
          value: EMERGENCY_CONTACT_OPTIONS.RELATIONSHIP_TO_PATIENT
        },
        {
          title: "Patient - Emergency Contact - Full Name",
          value: EMERGENCY_CONTACT_OPTIONS.FULL_NAME
        },
        {
          title: "Patient - Emergency Contact - First Name",
          value: EMERGENCY_CONTACT_OPTIONS.FIRST_NAME
        },
        {
          title: "Patient - Emergency Contact - Last Name",
          value: EMERGENCY_CONTACT_OPTIONS.LAST_NAME
        },
        {
          title: "Patient - Emergency Contact - Phone Number",
          value: EMERGENCY_CONTACT_OPTIONS.PHONE_NUMBER
        },
        {
          title: "Patient - Emergency Contact - Full Address",
          value: EMERGENCY_CONTACT_OPTIONS.FULL_ADDRESS
        },
        {
          title: "Patient - Emergency Contact - Street Address Line 1",
          value: EMERGENCY_CONTACT_OPTIONS.STREET_ADDRESS_LINE1
        },
        {
          title: "Patient - Emergency Contact - Street Address Line 2",
          value: EMERGENCY_CONTACT_OPTIONS.STREET_ADDRESS_LINE2
        },
        {
          title: "Patient - Emergency Contact - City",
          value: EMERGENCY_CONTACT_OPTIONS.CITY
        },
        {
          title: "Patient - Emergency Contact - State",
          value: EMERGENCY_CONTACT_OPTIONS.STATE
        },
        {
          title: "Patient - Emergency Contact - ZIP Code",
          value: EMERGENCY_CONTACT_OPTIONS.ZIP_CODE
        }
      ]
    },
    {
      title: "Employment",
      menu: [
        {
          title: "Patient - Employment Status",
          value: EMPLOYMENT_OPTIONS.STATUS
        },
        {
          title: "Patient - Employer Name",
          value: EMPLOYMENT_OPTIONS.EMPLOYER_NAME
        }
      ]
    },
    {
      title: "Referring Physician",
      menu: [
        {
          title: "Patient - Referring Physician - Full Name",
          value: REFERRING_PHYSICIAN_OPTIONS.FULL_NAME
        },
        {
          title: "Patient - Referring Physician - First Name",
          value: REFERRING_PHYSICIAN_OPTIONS.FIRST_NAME
        },
        {
          title: "Patient - Referring Physician - Last Name",
          value: REFERRING_PHYSICIAN_OPTIONS.LAST_NAME
        },
        {
          title: "Patient - Referring Physician - NPI",
          value: REFERRING_PHYSICIAN_OPTIONS.NPI
        },
        {
          title: "Patient - Referring Physician - Email",
          value: REFERRING_PHYSICIAN_OPTIONS.EMAIL
        },
        {
          title: "Patient - Referring Physician - Phone",
          value: REFERRING_PHYSICIAN_OPTIONS.PHONE
        },
        {
          title: "Patient - Referring Physician - Fax Number",
          value: REFERRING_PHYSICIAN_OPTIONS.FAX_NUMBER
        },
        {
          title: "Patient - Referring Physician - Address",
          value: REFERRING_PHYSICIAN_OPTIONS.ADDRESS
        },
        {
          title: "Patient - Referring Physician - Practice Name",
          value: REFERRING_PHYSICIAN_OPTIONS.PRACTICE_NAME
        }
      ]
    },
    {
      title: "Primary Care Physician",
      menu: [
        {
          title: "Patient - Primary Care Physician - Full Name",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.FULL_NAME
        },
        {
          title: "Patient - Primary Care Physician - First Name",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.FIRST_NAME
        },
        {
          title: "Patient - Primary Care Physician - Last Name",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.LAST_NAME
        },
        {
          title: "Patient - Primary Care Physician - NPI",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.NPI
        },
        {
          title: "Patient - Primary Care Physician - Email",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.EMAIL
        },
        {
          title: "Patient - Primary Care Physician - Phone",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.PHONE
        },
        {
          title: "Patient - Primary Care Physician - Fax Number",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.FAX_NUMBER
        },
        {
          title: "Patient - Primary Care Physician - Address",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.ADDRESS
        },
        {
          title: "Patient - Primary Care Physician - Practice Name",
          value: PRIMARY_CARE_PHYSICIAN_OPTIONS.PRACTICE_NAME
        }
      ]
    },

    {
      title: "Miscellaneous",
      menu: [
        {
          title: "Patient - Preferred Provider - Name",
          value: PATIENT_MISCELLANEOUS_OPTIONS.PREFERRED_PROVIDER_FULL_NAME
        },
        {
          title: "Patient - Preferred Provider - Signature",
          value: PATIENT_MISCELLANEOUS_OPTIONS.PREFERRED_PROVIDER_SIGNATURE
        },
        {
          title: "Patient - Preferred Clinic",
          value: PATIENT_MISCELLANEOUS_OPTIONS.PREFERRED_CLINIC
        },
        {
          title: "Patient - Segment",
          value: PATIENT_MISCELLANEOUS_OPTIONS.SEGMENT
        },
        {
          title: "Patient - Referral Source",
          value: PATIENT_MISCELLANEOUS_OPTIONS.REFERRAL_SOURCE
        },
        {
          title: "Patient - Sub Referral Source",
          value: PATIENT_MISCELLANEOUS_OPTIONS.SUB_REFERRAL_SOURCE
        },
        {
          title: "Patient - Tags",
          value: PATIENT_MISCELLANEOUS_OPTIONS.TAGS
        },
        {
          title: "Patient - HIPAA Signed Date",
          value: PATIENT_MISCELLANEOUS_OPTIONS.HIPAA_SIGNED_DATE
        },
        {
          title: "Patient - Diagnosis Codes",
          value: PATIENT_MISCELLANEOUS_OPTIONS.DIAGNOSIS_CODES
        },
        {
          title: "Patient - Signature",
          value: PATIENT_MISCELLANEOUS_OPTIONS.SIGNATURE
        }
      ]
    }
  ]
});

export const PATIENT_INFO_MENU_OPTIONS = buildPatientInfoMenuOptions(false);
export const PATIENT_INFO_MENU_OPTIONS_WITH_PRONOUNS =
  buildPatientInfoMenuOptions(true);
